import {
  getDoc,
} from 'firebase/firestore'
import { getTenantContextInstance as tenantCtx } from '@/plugins/tenant'

export default {
  namespaced: true,
  state: {
    featureFlags: {},
  },
  getters: {
    getFeatureFlags: state => state.featureFlags,
  },
  mutations: {
    SET_FEATURE_FLAGS(state, payload) {
      state.featureFlags = payload
    },
  },
  actions: {
    /**
     * Fetches the tenant's feature flags.
     *
     * @param {Object} commit
     *
     * @returns {Promise} Retrieves all fields in the document as an Object.
     */
    async fetchFeatureFlags({ commit }) {
      const { tenant } = tenantCtx()

      return new Promise((resolve, reject) => {
        getDoc(tenant)
          .then(docSnapshot => {
            if (!docSnapshot.exists()) {
              resolve()
            }

            const data = docSnapshot.data()

            if (!data.featureFlags) {
              resolve()
            }

            commit('SET_FEATURE_FLAGS', data.featureFlags)

            resolve(data.featureFlags)
          })
          .catch(error => {
            console.debug(error)

            reject(error)
          })
      })
    },
  },
}
